jQuery(document).ready(function ($) {

    $(window).on('scroll', function () {
        scroll = $(window).scrollTop();
        if (scroll >= 100) {
            $("#masthead").addClass("sticky");
        } else {
            $("#masthead").removeClass("sticky");
        }
    });
    $('#masthead ul.menu li a[aria-current="page"]').on('click', function (e) {
        e.preventDefault();
    })
    if ($(window).width() > 760) {
        $('.search-btn').on('click', function (e) {
            if ($(this).hasClass('disabled') || $('#search').val().length === 0) {
                e.preventDefault();
                $(this).removeClass('disabled');
                $(this).parent().addClass('active');
                $('#masthead').addClass('search-active');
            } else {
                // Submit Form
                $(this).parent().trigger('submit');
                // Clear search input
                $('#search').val('');
                // $('#masthead').removeClass('search-active');

            }
        })

        $('.search-close').on('click', function (e) {
            e.preventDefault();
            $('#masthead').removeClass('search-active');
            $(this).parent().removeClass('active');
            $('#masthead form').trigger('reset');
        })

    }
    if ($(window).width() <= 760) {
        //Create div and move elements inside
        $('#masthead').append('<div class="mobile-menu-wrapper"></div>');
        $('#masthead  .mobile-menu-wrapper').append($('#primary-menu'));
        $('#masthead  .mobile-menu-wrapper').append($('#masthead form'));

        $('#masthead ul.menu li.menu-item-has-children').on('click', function (e) {
            e.preventDefault();
            $(this).toggleClass('active')
            $(this).find('.sub-menu').slideToggle();
        })
        // Follow Link
        $('#masthead ul.menu li.menu-item-has-children .sub-menu li a').on('click', function (e) {
            e.preventDefault();
            window.location.href = $(this).attr('href');
        })
    }
    $('#burger-menu label input').on('click', function () {
        if ($('#masthead').hasClass('menu-active')) {
            $('#masthead').removeClass('menu-active');
            $('body').removeClass('overflow-hidden backdrop-active');
        } else {

            $('body').addClass('overflow-hidden backdrop-active');
            $('#masthead').addClass('menu-active');
        }
    })

    if (!$("body").hasClass("home")) {
        $(".animsition").css("padding-top", $("#masthead").outerHeight());
    }
});
